// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._2LweGvT2VEI2w7sYtvoL_C {\n  max-width: 100%;\n}\n\n.mntr4439yQc6DtNyQyIcL {\n  display: inline-flex;\n  align-items: center;\n}\n\n._3XX1zaOFUD9fpP1wNW_G_a {\n  justify-content: center;\n  text-align: center;\n}\n\n/*\n.buttonFlex:global(.btn) :global(.fa) {\n  line-height: 1.846;\n}\n*/\n\n.mntr4439yQc6DtNyQyIcL.btn.btn-xs .fa {\n  line-height: 1.5;\n}\n\n._2LweGvT2VEI2w7sYtvoL_C span {\n  overflow-x: hidden;\n  text-overflow: ellipsis;\n}\n\n._2LweGvT2VEI2w7sYtvoL_C > i:not(:only-child) {\n  margin-right: 4px;\n}\n\n.btn-block+.btn-block {\n  margin-top: 0;\n}\n", ""]);
// Exports
exports.locals = {
	"button": "_2LweGvT2VEI2w7sYtvoL_C",
	"buttonFlex": "mntr4439yQc6DtNyQyIcL",
	"centerButton": "_3XX1zaOFUD9fpP1wNW_G_a"
};
module.exports = exports;
